<app-metrics-dimensions-picker [type]="paramDef.options.type"
                               [controlName]="paramDef.controlName"
                               [form]="form"
                               [control]="control"
                               [max]="paramDef.options.max"
                               [categories]="categories$ | async"
                               [sources]="sources$ | async"
                               [options]="options$ | async"
                               [disabledOptions]="disabledValues$ | async"></app-metrics-dimensions-picker>
